export default __webpack_public_path__ + "static/media/image_empty_error.4f538dfa.png";